export const SET_CLOCKLOG = 'clocklog.set'
export const EMAILS_RESET_PAGINATION = 'EMAILS_RESET_PAGINATION'
export const EMAILS_SET_GAPI = 'EMAILS_SET_GAPI'
export const EMAILS_SET_IS_SIGNED_IN = 'EMAILS_SET_IS_SIGNED_IN'
export const EMAILS_SET_LABEL = 'EMAILS_SET_LABEL'
export const EMAILS_SET_LABELS = 'EMAILS_SET_LABELS'
export const EMAILS_SET_MESSAGE = 'EMAILS_SET_MESSAGE'
export const EMAILS_SET_MESSAGES = 'EMAILS_SET_MESSAGES'
export const EMAILS_SET_PAGINATION = 'EMAILS_SET_PAGINATION'
export const EMAILS_SET_PROFILE = 'EMAILS_SET_PROFILE'
export const EMAILS_SET_QUERY = 'EMAILS_SET_QUERY'
export const SET_USERS = 'users.set'
export const ADD_OR_UPDATE_USER = 'users.add-or-update'
export const SET_CURRENT_USER = 'users.set-current-user'
export const REMOVE_USER = 'users.remove'
export const SET_USER_SETTING = 'users.set-setting'

export const ADD_OR_UPDATE_TEAM = 'teams.add-or-update'
export const REMOVE_TEAM = 'teams.remove'

export const ADD_OR_UPDATE_NOTIFICATION = 'notifications.add-or-update'
export const ADD_OR_UPDATE_NOTIFICATION_COUNT = 'notifications.count'
export const REMOVE_NOTIFICATION = 'notifications.remove'

export const ADD_OR_UPDATE_COMPANY = 'companies.add-or-update'
export const REMOVE_COMPANY = 'companies.remove'
export const SET_COMPANIES = 'companies.set'

export const SET_CONTACTS = 'contacts.set'
export const ADD_OR_UPDATE_CONTACT = 'contacts.add-or-update'
export const REMOVE_CONTACT = 'contacts.remove'

export const ADD_OR_UPDATE_TASK = 'tasks.add-or-update'
export const REMOVE_TASK = 'tasks.remove'
export const SET_TASKS_TOTAL = 'tasks.set-total'

export const SET_PERMIT_TYPES = 'permit-types.set'
export const ADD_OR_UPDATE_PERMIT_TYPE = 'permit-types.add-or-update'
export const REMOVE_PERMIT_TYPE = 'permit-types.remove'

export const SET_WORK_TYPES = 'work-types.set'
export const ADD_OR_UPDATE_WORK_TYPE = 'work-types.add-or-update'
export const REMOVE_WORK_TYPE = 'work-types.remove'

export const SET_SERVICES = 'services.set'
export const ADD_OR_UPDATE_SERVICE = 'services.add-or-update'
export const REMOVE_SERVICE = 'services.remove'

export const ADD_OR_UPDATE_FILE = 'files.add-or-update'
export const REMOVE_FILE = 'files.remove'

export const SET_PROJECTS = 'projects.set'
export const ADD_OR_UPDATE_PROJECT = 'projects.add-or-update'
export const REMOVE_PROJECT = 'projects.remove'
export const SET_PROJECTS_TOTAL = 'projects.set-total'
export const SET_CURRENT_PROJECT_ID = 'projects.set-current-project-id'

export const ATTACH_PROJECT_CONTACT = 'project-contacts.attach'
export const DETACH_PROJECT_CONTACT = 'project-contacts.detach'

export const SET_FOLLOWED_PROJECTS = 'followed-projects.set'
export const ADD_OR_UPDATE_FOLLOWED_PROJECT = 'followed-projects.add-or-update'
export const REMOVE_FOLLOWED_PROJECT = 'followed-porjects.remove'

export const ADD_OR_UPDATE_PROPOSAL = 'proposals.add-or-update'
export const REMOVE_PROPOSAL = 'proposals.remove'
export const SET_PROPOSALS_TOTAL = 'proposals.set-total'

export const SET_PROPOSAL_STATUSES_SUMMARY = 'stats.set-proposal-statuses-summary'
export const SET_PROPOSALS_LEAD_SOURCES = 'stats.set-proposals-lead-sources'

export const ADD_OR_UPDATE_CHANGE_ORDER = 'change-orders.add-or-update'
export const REMOVE_CHANGE_ORDER = 'change-orders.remove'

export const ADD_OR_UPDATE_PROJECT_SERVICE = 'project-services.add-or-update'
export const REMOVE_PROJECT_SERVICE = 'project-services.remove'
export const ADD_OR_UPDATE_EDITING_PROJECT_SERVICE = 'editing.project-services.add-or-update'
export const REMOVE_EDITING_PROJECT_SERVICE = 'editing.project-services.remove'
export const REORDER_EDITING_PROJECT_SERVICES = 'editing.project-services.reorder'
export const SET_EDITING_PROJECT_SERVICES = 'editing.project-services.set'

export const ADD_OR_UPDATE_TIMELOG = 'timelogs.add-or-update'
export const REMOVE_TIMELOG = 'timelogs.remove'
export const OPEN_GLOBAL_TIMELOG = 'timelogs.open-global'
export const CLOSE_GLOBAL_TIMELOG = 'timelogs.close-global'

export const ADD_OR_UPDATE_REMINDER = 'reminders.add-or-update'
export const REMOVE_REMINDER = 'reminders.remove'

export const ADD_OR_UPDATE_ACTIVITY = 'activities.add-or-update'
export const REMOVE_ACTIVITY = 'activities.remove'

export const ADD_OR_UPDATE_NOTE = 'notes.add-or-update'
export const REMOVE_NOTE = 'notes.remove'

export const ADD_OR_UPDATE_CHECKLIST = 'checklist.add-or-update'
export const REMOVE_CHECKLIST = 'checklist.remove'

export const ADD_OR_UPDATE_SUBSCRIBER = 'subscribers.add-or-update'
export const REMOVE_SUBSCRIBER = 'subscribers.remove'

export const ADD_OR_UPDATE_SUBSCRIBED_CONTACT = 'subscribed-contacts.add-or-update'
export const REMOVE_SUBSCRIBED_CONTACT = 'subscribed-contacts.remove'

export const ADD_OR_UPDATE_HISTORICAL_DATA = 'historical-data.add-or-update'

export const TOGGLE_SIDEBAR = 'menu.toggle_sidebar'
export const CLOSE_SIDEBAR = 'menu.close_sidebar'
export const ADD_OR_UPDATE_SETTING = 'settings.add-or-update'
export const SET_SETTINGS = 'settings.set'

export const APP_HYDRATED = 'auth.app-hydrated'

export const SET_DICTIONARIES = 'dictionaries.set'
export const ADD_OR_UPDATE_DICTIONARY_ENTRY = 'dictionaries.add-or-update'
export const REMOVE_DICTIONARY_ENTRY = 'dictionaries.remove'

export const ADD_OR_UPDATE_PROPOSAL_STATS = 'proposal-stats.add-or-update'
export const ADD_OR_UPDATE_APPLICATION_UNDER_REVIEW = 'applications-under-review.add-or-update'
export const ADD_OR_UPDATE_APPLICATION_SIGNED_OFF = 'applications-signed-off.add-or-update'

export const SET_TABLE_SETTINGS = 'table-settings.set'
export const ADD_OR_UPDATE_TABLE_SETTING = 'table-settings.add-or-update'
export const REMOVE_TABLE_SETTING = 'table-settings.remove'

export const OPEN_MESSAGE_MODAL = 'global-states.open-message-modal'
export const CLOSE_MESSAGE_MODAL = 'global-states.close-message-modal'
export const SET_FORCE_ROUTE_KEY = 'global-states.set-force-route-key'

export const APPLY_TABLE_VIEW = 'table-views.apply'
export const ADD_OR_UPDATE_TABLE_VIEW = 'table-views.add-or-update'
export const REMOVE_TABLE_VIEW = 'table-views.remove'
export const SET_TABLE_COLUMN_NAMES = 'table-views.set-column-names'

export const ADD_OR_UPDATE_ROLE = 'roles.add-or-update'
export const REMOVE_ROLE = 'roles.remove'
export const SET_ROLES = "roles.set"
